import gql from 'graphql-tag'

export const CONSULTANT_NOTIFICATION_EMAIL_ADDRESS_UPDATE_MUTATION = gql`
    mutation consultantNotificationEmailAddressUpdate(
        $consultantNotificationEmailAddress: ConsultantNotificationEmailAddressInput!
    ) {
        consultantNotificationEmailAddressUpdate(
            consultantNotificationEmailAddress: $consultantNotificationEmailAddress
        ) {
            id
            email
            notificationEmitters
            created_at
            updated_at
        }
    }
`
